import { Box } from "@mui/material"

const validateData = (data) => {

    const response = []

    if (!data?.nome?.length > 0)
        response.push(<Box>Digite o nome da catraca.</Box>)

    if (response.length === 0)
        return ''

    return (response)
}

export default validateData